import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';

const HomeTemplate = ({ pageContext }) => {
  const { metaData } = pageContext;
  return <Helmet title={`${metaData.metaTitle} | ${metaData.siteName}`} />;
};

export default HomeTemplate;

export const homeQuery = graphql`
  query HomeQuery($siteId: String!) {
    contentfulSettings(id: { eq: $siteId }) {
      intro {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
